import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CererePriorityComponent } from './cerere-priority.component';
import { AddCererePriorityComponent } from './add-cerere-priority/add-cerere-priority.component';
import { EditCererePriorityComponent } from './edit-cerere-priority/edit-cerere-priority.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    CererePriorityComponent, 
    AddCererePriorityComponent, 
    EditCererePriorityComponent
  ],
  imports: [
    CommonModule, 
    ReactiveFormsModule, 
    FormsModule, 
    MaterialModule
  ],
  exports: [AddCererePriorityComponent, CererePriorityComponent],
//   schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CererePriorityModule {}
